/* ERC-20 `transfer(address,uint256)` calldata, encoded by hand.

   This app already talks to wallets over raw EIP-1193 rather than through
   wagmi or viem — see `sign.ts` — and one ABI call does not justify a chain
   library: the encoding is a four-byte selector followed by two 32-byte words,
   each an argument right-aligned in hex. */

export const TRANSFER_SELECTOR = "0xa9059cbb";

export const EVM_ADDRESS = /^0x[0-9a-fA-F]{40}$/;

/* Every EVM word is 32 bytes — 64 hex characters — with the value flush right
   and the space before it zero-filled. */
const word = (hex: string) => {
  if (hex.length > 64) {
    throw new Error("Value does not fit in a 32-byte word.");
  }

  return hex.toLowerCase().padStart(64, "0");
};

export const transferCallData = (recipient: string, amount: bigint) => {
  if (!EVM_ADDRESS.test(recipient)) {
    throw new Error("Recipient is not an EVM address.");
  }

  if (amount < 0n) {
    throw new Error("Amount cannot be negative.");
  }

  return `${TRANSFER_SELECTOR}${word(recipient.slice(2))}${word(amount.toString(16))}`;
};

/* The JSON-RPC "quantity" encoding: hex, `0x`-prefixed, no leading zeroes.
   `wallet_switchEthereumChain` reads chain ids in this form and rejects the
   decimal number some wallets otherwise accept. */
export const toQuantity = (value: bigint | number) => `0x${value.toString(16)}`;
